<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space article-price-editor">
    <sc-dialog-title>
      {{ 'Preis' | translate: ['erp.ui.article-price-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <div>
        <form [formGroup]="formGroup">
            <sc-flex [vertical]="true" [stretchContent]="true">
                <sc-padding>
                    <sc-flex >
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Von' | translate: ['erp.entity.price.valid-from', translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="date_from" required="true" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer></sc-content-spacer>
                        <mat-form-field appearance="fill" class="date-field">
                            <mat-label>{{ 'Bis' | translate: ['erp.entity.price.valid-until', translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="date_until" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer [grow]="true"></sc-content-spacer>
                        <mat-form-field appearance="fill" *ngIf="mode == 'costs'">
                            <mat-label>{{ 'Quelle' | translate: ['erp.entity.price.source', translationService.language]}}</mat-label>
                          <!--(selectionChange)="selectionChanged($event)"-->
                          <mat-select [required]="true" formControlName="source">
                            <mat-option *ngFor="let o of costsPriceSources" value="{{o}}">
                              {{o}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <sc-content-spacer *ngIf="mode == 'costs'"></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Referenzdatum' | translate: ['erp.entity.price.referencedate', translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker3" formControlName="reference">
                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                        </mat-form-field>
                    </sc-flex>
                </sc-padding>

                <sc-separator-line></sc-separator-line>

                <sc-padding>

                    <mat-radio-group class="price-radio-group" *ngIf="allowBasicPriceSelectionOption == true" formControlName="useBasicPrice">
                        <sc-flex [vertical]="true" [stretchContent]="true">
                            <mat-radio-button value="true">
                                <sc-flex >
                                    <sc-content-spacer></sc-content-spacer>
                                    {{ 'Basispreis verwenden' | translate: ['erp.entity.price.use-basicprice', translationService.language]}}
                                </sc-flex>
                            </mat-radio-button>
                            <mat-radio-button value="false">
                                <sc-flex >
                                    <sc-content-spacer></sc-content-spacer>
                                    <mat-form-field appearance="fill">
                                        <mat-label>{{ 'Netto' | translate: ['erp.entity.price.price-net',
                                            translationService.language]}}</mat-label>
                                        <span matSuffix>€</span>
                                        <input matInput acNumberInput [scale]="priceScale" formControlName="price_net" [required]="!useBasicPriceOptionSelected">
                                    </mat-form-field>

                                    <ng-container *ngIf="!hideVatPrices">
                                      <sc-content-spacer></sc-content-spacer>
                                      <mat-form-field appearance="fill">
                                          <mat-label>{{ 'MwSt (%)' | translate: ['erp.entity.price.tax-rate',
                                              translationService.language]}}</mat-label>
                                          <input matInput acNumberInput [scale]="0" formControlName="tax_rate">
                                          <span matSuffix>%</span>
                                      </mat-form-field>
                                        <sc-content-spacer></sc-content-spacer>
                                        <mat-form-field appearance="fill">
                                            <mat-label>{{ 'Brutto' | translate: ['erp.entity.price.price-vat',
                                                translationService.language]}}</mat-label>
                                            <input matInput acNumberInput [scale]="priceScale" formControlName="price_vat">
                                            <span matSuffix>€</span>
                                        </mat-form-field>

                                    </ng-container>
                                </sc-flex>
                            </mat-radio-button>
                        </sc-flex>
                    </mat-radio-group>

                    <sc-flex *ngIf="allowBasicPriceSelectionOption == false">
                        <mat-form-field appearance="fill" class="number-field">
                            <mat-label>{{ 'Netto' | translate: ['erp.entity.price.price-net', translationService.language]}}</mat-label>
                            <input matInput acNumberInput [scale]="priceScale" formControlName="price_net" [required]="true">
                        </mat-form-field>
                        <ng-container *ngIf="!hideVatPrices">

                          <sc-content-spacer></sc-content-spacer>
                          <mat-form-field appearance="fill" class="number-field">
                              <mat-label>{{ 'MwSt (%)' | translate: ['erp.entity.price.tax-rate', translationService.language]}}</mat-label>
                              <input matInput acNumberInput [scale]="0" formControlName="tax_rate">
                          </mat-form-field>

                          <sc-content-spacer></sc-content-spacer>
                          <mat-form-field appearance="fill" class="number-field">
                              <mat-label>{{ 'Brutto' | translate: ['erp.entity.price.price-vat', translationService.language]}}</mat-label>
                              <input matInput acNumberInput [scale]="priceScale" formControlName="price_vat">
                          </mat-form-field>
                        </ng-container>
                    </sc-flex>
                </sc-padding>

                <div class="costsPriceAttributes" *ngIf="mode == 'costs'">
                  <sc-padding>
                    <sc-flex [stretchContent]="true">
                    <ng-container *ngFor="let group of costsPriceAttributeGroups; let i = index" >
                      <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
                      <sc-flex-fitting-content>
                        <sc-bordered-tile>
                          <sc-padding>
                            <app-attribute-group [formGroup]="formGroup" [attributeGroup]="group" [valuesMap]="price.valuesMap" [usage]="group.usage"></app-attribute-group>
                          </sc-padding>
                        </sc-bordered-tile>
                    </sc-flex-fitting-content>
                    </ng-container>
                    </sc-flex>
                  </sc-padding>
                </div>

                <div class="calculation-rules" *ngIf="mode === 'retail'" >
                  <sc-separator-line></sc-separator-line>
                    <sc-padding>
                        <sc-flex [vertical]="true" [stretchContent]="true">
                            <ng-container *ngFor="let rule of articleType.calculationRules; let i = index">
                                <sc-content-spacer [vertical]="true" *ngIf="i > 0"></sc-content-spacer>
                                <sc-flex >
                                    <sc-icon iconClass="fa-plus fa-2x" *ngIf="rule.method == 'ADD'"></sc-icon>
                                    <sc-icon iconClass="fa-minus fa-2x" *ngIf="rule.method == 'SUBTRACT'"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <app-dictionary-entry-label [model]="rule.name"></app-dictionary-entry-label>
                                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                                    <mat-form-field appearance="fill" class="number-field">
                                        <mat-label>{{ 'Count' | translate: ['erp.entity.calculationrule.count', translationService.language]}}
                                        </mat-label>
                                        <input matInput acNumberInput [scale]="2" [formControlName]="'rule_count_' + rule.id">
                                    </mat-form-field>
                                    <sc-content-spacer></sc-content-spacer>
                                    <sc-icon iconClass="fa-xmark fa-2x"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <mat-form-field appearance="fill" class="number-field">
                                        <mat-label>{{ 'Faktor' | translate: ['erp.entity.calculationrule.factor', translationService.language]}}
                                        </mat-label>
                                        <input matInput acNumberInput [scale]="3" [formControlName]="'rule_faktor_' + rule.id">
                                    </mat-form-field>
                                    <sc-content-spacer></sc-content-spacer>
                                    <sc-icon iconClass="fa-equals fa-2x"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <div class="sum-column">
                                        {{ calculationResults.get(rule.id)  | numberFormat:priceScale}}
                                    </div>
                                </sc-flex>
                            </ng-container>
                        </sc-flex>
                    </sc-padding>
                </div>

                <sc-separator-line></sc-separator-line>

                <div class="resulting-price">
                  <sc-padding>
                      <sc-flex [stretchContent]="true">
                        <div>{{'Resultierender Preis' | translate: ['erp.ui.article-price-editor.label.resulting-price', translationService.language]}}</div>
                        <sc-content-spacer ></sc-content-spacer>
                        <mat-form-field appearance="fill" *ngIf="allowBasicPriceSelectionOption == true && useBasicPriceOptionSelected">
                          <mat-label>{{ 'Stichtag Preis' | translate: ['erp.ui.article-price-editor.label.label.basicarticleprice.referenceDate',
                              translationService.language]}}</mat-label>
                          <input matInput [matDatepicker]="picker4" formControlName="resultingprice_calculation_date">
                          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                          <mat-datepicker #picker4></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer [grow]="true"></sc-content-spacer>
                        <div>{{resultingPriceNet | numberFormat:priceScale}} €</div>
                      </sc-flex>
                  </sc-padding>
                </div>
            </sc-flex>
        </form>
    </div>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.article-price-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          {{ 'Übernehmen' | translate: ['erp.ui.article-price-editor.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
